import { MenuItem, Select, Typography } from "@mui/material";
import { FormControl } from "@material-ui/core";
import DropdownIcon from "../../DropdownIcon";
import { useSearch } from "../../../hooks/seach/useSearch";
import { styles } from "./styles";

export default function StepStatus() {
    const {
        stepStatus, setStepStatus
    } = useSearch();

    return (
        <>
            <Typography style={styles.labelInput}>
                Etapa dos Status:
            </Typography>
            <FormControl variant="outlined" style={styles.formControl}>
                <Select
                    IconComponent={DropdownIcon}
                    value={stepStatus}
                    onChange={(e) => { setStepStatus(e.target.value); }}
                    style={{ 'background': '#fff' }}
                >
                    <MenuItem value="Todos">Todos</MenuItem>
                    <MenuItem value="Abertura">Abertura</MenuItem>
                    <MenuItem value="Homologação">Homologação</MenuItem>
                    <MenuItem value="Execução">Execução</MenuItem>
                    <MenuItem value="Conclusão">Conclusão</MenuItem>
                </Select>
            </FormControl>
        </>
    )
}